<script type="text/jsx">
import Add from './add';
import Trial2paid from './trial2paid';
import AddTrial from './addTrial';
import Edit from './edit';
import BuyNow from './buy-now';
import EditDelta from './edit-delta.vue';
import planPropsMixin from '@/plans/mx/plan-props';
import planCommonMixin from '@/plans/EVENT_SAAS_CORE/mixin';
import { mapGetters } from 'vuex';
import canAutoAdd from '@/components/capacity/mx/canAutoAdd';

export default {
  mixins: [planPropsMixin, canAutoAdd, planCommonMixin],
  computed: {
    ...mapGetters(['getSelectedPlans']),
    selectedPlanList() {
      return this.getSelectedPlans;
    },
  },
  render() {
    const context = {...{ props: { ...this.$attrs, ...this.$props }, on: { ...this.$listeners }}};
    // FREE TRIAL
    if (this.$context.is.add2trial) return <AddTrial {...context} />;
    if (this.$context.is.add2cart) return <Add {...context} />;
    if (this.$context.is.trial2paid) return <Trial2paid {...context} />;
    if (this.$context.is.edit) {
      if (this.$context.is.addQty && this.mx_canAutoAdd) {
        return <EditDelta {...context} />;
      }
      return <Edit {...context} />;
    }
    return <BuyNow {...context} />;
  },
};
</script>
